import ar from "./i18n/ar.json";
import de from "./i18n/de.json";
import en from "./i18n/en.json";
import es from "./i18n/es.json";
import fi from "./i18n/fi.json";
import fr from "./i18n/fr.json";
import id from "./i18n/id.json";
import ja from "./i18n/ja.json";
import ko from "./i18n/ko.json";
import no from "./i18n/no.json";
import pt from "./i18n/pt.json";
import th from "./i18n/th.json";
import tr from "./i18n/tr.json";
import vi from "./i18n/vi.json";
import zh from "./i18n/zh.json";

const translations: Record<string, Record<string, string>> = {
  en,
  ar,
  de,
  es,
  fi,
  fr,
  id,
  ja,
  ko,
  no,
  pt,
  th,
  tr,
  vi,
  zh,
};

export default translations;
